import { Route } from '@angular/router';
import { loggedInGuard } from '../lib/shared/services/supabase.service';

export const appRoutes: Route[] = [
    {
        path: '',
        loadComponent: async () => (await import('../lib/landing/landing.component')).LandingComponent
    },
    {
        path: 'profile',
        loadComponent: async () => (await import('../lib/profile/profile.container')).ProfileContainer,
        canActivate: [loggedInGuard],
    },
    {
        path: 'shop',
        loadComponent: async () => (await import('../lib/shop/shop.container')).ShopContainer,
    },
    {
        path: 'suitcase',
        loadComponent: async () => (await import('../lib/suitcase/suitcase.container')).SuitcaseContainer,
        canActivate: [loggedInGuard],
    },
    {
        path: 'about',
        loadComponent: async () => (await import('../lib/about/about.container')).AboutContainer,
    },
    {
        path: 'privacy-policy',
        loadComponent: async () => (await import('../lib/privacy-policy/privacy-policy.container')).PrivacyPolicyContainer,
    },
    {
        path: 'terms-of-service',
        loadComponent: async () => (await import('../lib/terms-of-service/terms-of-service.container')).TermsOfServiceContainer,
    },
];
